// src/modules/obras/modalRDO.js — Porte FIEL do RDO desktop do monolito.
// openModalNovoRegistro + helpers _pc* + _supRdoCarregarTarefas/_supRdoTarefaUpdate + salvarRDO.
// Usa openModal({size:'large'}) (o monolito usa showModal large, não premium).

import { openModal, closeModal } from '../../components/modal.js';
import { comprimirImagem } from '../../lib/imageCompress.js';
import { sb } from '../../api/supabaseClient.js';
import { tenant } from '../../context/tenantContext.js';
import { showToast } from '../../lib/toast.js';
import { esc } from '../../lib/dom.js';

// ─── Estado do form (mesmo do monolito, encapsulado no módulo) ──────────
let rdoClima = '';
let _pcRdoV4 = { efetivoPorFuncao: [], ddsRealizado: null, episEmUso: [], paralisacoes: [] };
let _supRdoTarefasCache = [];
let _supRdoTarefasData = {};
let _onSavedCb = null;

const _pcEPI_OPTIONS = [
  { v: 'capacete', l: 'Capacete' }, { v: 'bota', l: 'Bota' }, { v: 'luva', l: 'Luva' },
  { v: 'oculos', l: 'Óculos' }, { v: 'cinto', l: 'Cinto' }, { v: 'protetor', l: 'Prot. auricular' },
  { v: 'mascara', l: 'Máscara' }, { v: 'colete', l: 'Colete' },
];

// ─── Clima ──────────────────────────────────────────────────────────────
function selecionarClima(val, el) {
  rdoClima = val;
  document.querySelectorAll('.clima-opt').forEach((e) => e.classList.remove('selected'));
  el.classList.add('selected');
}

// ─── Efetivo por função ───────────────────────────────────────────────
function _pcRdoInit() {
  _pcRdoV4 = { efetivoPorFuncao: [], ddsRealizado: null, episEmUso: [], paralisacoes: [] };
}
function _pcRdoAddFuncao() {
  _pcRdoV4.efetivoPorFuncao.push({ funcao: '', qtd: 1 });
  _pcRdoRenderEfetivo();
  _pcRdoUpdateEfetivoTotalPC();
}
function _pcRdoUpdateFuncao(idx, field, value) {
  const f = _pcRdoV4.efetivoPorFuncao[idx]; if (!f) return;
  f[field] = field === 'qtd' ? (parseInt(value) || 0) : value;
  _pcRdoUpdateEfetivoTotalPC();
}
function _pcRdoRemoveFuncao(idx) {
  _pcRdoV4.efetivoPorFuncao.splice(idx, 1);
  _pcRdoRenderEfetivo();
  _pcRdoUpdateEfetivoTotalPC();
}
function _pcRdoUpdateEfetivoTotalPC() {
  const soma = _pcRdoV4.efetivoPorFuncao.reduce((s, f) => s + (parseInt(f.qtd) || 0), 0);
  const chip = document.getElementById('pc-rdo-efetivo-soma');
  if (chip) chip.textContent = soma ? `${soma} trabalhador${soma === 1 ? '' : 'es'}` : 'sem totais por função';
  if (soma > 0) {
    const ef = document.getElementById('m-efetivo');
    if (ef && !ef.dataset.touched) ef.value = soma;
  }
}
function _pcRdoRenderEfetivo() {
  const c = document.getElementById('pc-rdo-efetivo-list'); if (!c) return;
  c.innerHTML = (_pcRdoV4.efetivoPorFuncao || []).map((f, i) => `
    <div style="display:grid;grid-template-columns:1fr 90px 30px;gap:8px;margin-bottom:6px;align-items:center">
      <input type="text" placeholder="Função (Ex: Pedreiro)" value="${(f.funcao || '').replace(/"/g, '&quot;')}"
        oninput="_pcRdoUpdateFuncao(${i},'funcao',this.value)"
        style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:transparent;color:var(--text);font-size:13px">
      <input type="number" min="0" placeholder="Qtd" value="${f.qtd || ''}"
        oninput="_pcRdoUpdateFuncao(${i},'qtd',this.value)"
        style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:transparent;color:var(--text);font-size:13px;text-align:center">
      <button type="button" onclick="_pcRdoRemoveFuncao(${i})" title="Remover"
        style="width:30px;height:30px;border:none;background:transparent;color:var(--red);cursor:pointer;font-size:16px">✕</button>
    </div>`).join('');
}

// ─── DDS / EPIs ──────────────────────────────────────────────────────────
function _pcRdoSetDDS(val) {
  _pcRdoV4.ddsRealizado = val;
  document.querySelectorAll('[data-pc-dds]').forEach((b) => {
    const sel = b.dataset.pcDds === String(val);
    b.style.background = sel ? 'color-mix(in oklab, var(--sc-info) 10%, transparent)' : 'transparent';
    b.style.borderColor = sel ? 'var(--sc-info)' : 'var(--border)';
    b.style.color = sel ? 'var(--sc-info)' : 'var(--text)';
  });
}
function _pcRdoToggleEPI(epi, el) {
  const arr = _pcRdoV4.episEmUso;
  const i = arr.indexOf(epi);
  if (i >= 0) arr.splice(i, 1); else arr.push(epi);
  const sel = arr.includes(epi);
  if (el) {
    el.style.background = sel ? 'color-mix(in oklab, var(--sc-info) 10%, transparent)' : 'transparent';
    el.style.borderColor = sel ? 'var(--sc-info)' : 'var(--border)';
    el.style.color = sel ? 'var(--sc-info)' : 'var(--text)';
  }
}

// ─── Paralisações ────────────────────────────────────────────────────────
function _pcRdoAddParalisacao() {
  _pcRdoV4.paralisacoes.push({ motivo: '', inicio: '', fim: '', horas: 0 });
  _pcRdoRenderParalisacoes();
}
function _pcRdoUpdateParalisacao(idx, field, value) {
  const p = _pcRdoV4.paralisacoes[idx]; if (!p) return;
  if (field === 'horas') p.horas = Number(value) || 0;
  else p[field] = value;
  if ((field === 'inicio' || field === 'fim') && p.inicio && p.fim) {
    const [hi, mi] = p.inicio.split(':').map(Number);
    const [hf, mf] = p.fim.split(':').map(Number);
    if (!isNaN(hi) && !isNaN(hf)) {
      let mins = (hf * 60 + mf) - (hi * 60 + mi);
      if (mins < 0) mins += 24 * 60;
      p.horas = +(mins / 60).toFixed(2);
      const el = document.querySelector(`[data-par-horas="${idx}"]`);
      if (el) el.value = p.horas;
    }
  }
}
function _pcRdoRemoveParalisacao(idx) {
  _pcRdoV4.paralisacoes.splice(idx, 1);
  _pcRdoRenderParalisacoes();
}
function _pcRdoRenderParalisacoes() {
  const c = document.getElementById('pc-rdo-paralisacao-list'); if (!c) return;
  c.innerHTML = (_pcRdoV4.paralisacoes || []).map((p, i) => `
    <div style="background:transparent;border:0.5px solid var(--border);border-radius:8px;padding:10px;margin-bottom:6px">
      <div style="display:grid;grid-template-columns:1fr 90px 90px 80px 30px;gap:8px;align-items:center">
        <input type="text" placeholder="Motivo (chuva, falta material...)" value="${(p.motivo || '').replace(/"/g, '&quot;')}"
          oninput="_pcRdoUpdateParalisacao(${i},'motivo',this.value)"
          style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px">
        <input type="time" value="${p.inicio || ''}"
          oninput="_pcRdoUpdateParalisacao(${i},'inicio',this.value)"
          style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px">
        <input type="time" value="${p.fim || ''}"
          oninput="_pcRdoUpdateParalisacao(${i},'fim',this.value)"
          style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px">
        <input type="number" step="0.1" min="0" placeholder="h" value="${p.horas || ''}" data-par-horas="${i}"
          oninput="_pcRdoUpdateParalisacao(${i},'horas',this.value)"
          style="padding:8px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px;text-align:center">
        <button type="button" onclick="_pcRdoRemoveParalisacao(${i})"
          style="width:30px;height:30px;border:none;background:transparent;color:var(--red);cursor:pointer;font-size:16px">✕</button>
      </div>
    </div>`).join('');
}

// ─── Tarefas acompanhadas ──────────────────────────────────────────────
function _supRdoTarefaUpdate(tarefaId, field, value) {
  if (!_supRdoTarefasData[tarefaId]) {
    const t = _supRdoTarefasCache.find((t) => t.id === tarefaId);
    _supRdoTarefasData[tarefaId] = { titulo: t?.titulo || '?', etapa: t?.etapas_obra?.nome_etapa || null };
  }
  _supRdoTarefasData[tarefaId][field] = field === 'percentual' ? (+value || 0) : (field === 'atrasada' ? !!value : value);
}

async function _supRdoCarregarTarefas(obraId) {
  const el = document.getElementById('srdo-tarefas-lista');
  if (!el) return;
  const { data: tarefas } = await sb.from('tarefas')
    .select('id,titulo,status,prioridade,progresso,etapas_obra(nome_etapa)')
    .eq('obra_id', obraId).neq('status', 'cancelada').neq('status', 'concluida').order('created_at');
  _supRdoTarefasCache = tarefas || [];
  if (!_supRdoTarefasCache.length) {
    el.innerHTML = '<div style="color:var(--text3);font-size:12px;padding:6px 0;font-style:italic">Nenhuma tarefa ativa nesta obra.</div>';
    return;
  }
  const corPrio = { urgente: 'var(--red)', alta: 'var(--amber)', media: 'var(--sc-info)', baixa: 'var(--text3)' };
  el.innerHTML = _supRdoTarefasCache.map((t) => {
    const etapaLabel = t.etapas_obra?.nome_etapa ? `<span style="font-size:10px;color:var(--text3);flex-shrink:0">${esc(t.etapas_obra.nome_etapa)}</span>` : '';
    const prioBar = t.prioridade ? `<span style="width:8px;height:8px;border-radius:50%;background:${corPrio[t.prioridade] || 'var(--text3)'};flex-shrink:0;display:inline-block"></span>` : '';
    const progBar = t.progresso > 0
      ? `<div style="background:var(--border);border-radius:3px;height:3px;margin-bottom:8px"><div style="height:100%;background:var(--sc-info);border-radius:3px;width:${t.progresso}%"></div></div>`
      : '';
    return `
    <div style="background:transparent;border:0.5px solid var(--border);border-radius:10px;padding:12px;margin-bottom:10px">
      <div style="display:flex;align-items:center;gap:6px;margin-bottom:8px">${prioBar}<span style="font-size:12px;font-weight:700;flex:1;line-height:1.3">${esc(t.titulo)}</span>${etapaLabel}</div>
      ${progBar}
      <label style="font-size:10px;color:var(--text3);display:block;margin-bottom:3px">Andamento do dia</label>
      <textarea rows="2" placeholder="O que foi feito nesta tarefa hoje?"
        oninput="_supRdoTarefaUpdate('${t.id}','andamento',this.value)"
        style="width:100%;padding:7px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px;resize:vertical;box-sizing:border-box;margin-bottom:6px;font-family:inherit"></textarea>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:6px">
        <div>
          <label style="font-size:10px;color:var(--text3);display:block;margin-bottom:3px">% executado hoje</label>
          <input type="number" min="0" max="100" placeholder="${t.progresso || 0}"
            oninput="_supRdoTarefaUpdate('${t.id}','percentual',+this.value)"
            style="width:100%;padding:7px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px;box-sizing:border-box">
        </div>
        <div>
          <label style="font-size:10px;color:var(--text3);display:block;margin-bottom:3px">Impedimentos</label>
          <input type="text" placeholder="Bloqueio, falta de material..."
            oninput="_supRdoTarefaUpdate('${t.id}','impedimentos',this.value)"
            style="width:100%;padding:7px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px;box-sizing:border-box">
        </div>
      </div>
      <label style="font-size:10px;color:var(--text3);display:block;margin-bottom:3px">Materiais utilizados</label>
      <input type="text" placeholder="Ex: Cimento 50kg x 20, Areia m³..."
        oninput="_supRdoTarefaUpdate('${t.id}','materiais',this.value)"
        style="width:100%;padding:7px 10px;border-radius:8px;border:0.5px solid var(--border);background:var(--bg);color:var(--text);font-size:12px;box-sizing:border-box;margin-bottom:6px">
      <label style="display:flex;align-items:center;gap:6px;cursor:pointer;font-size:11px;color:var(--text2)">
        <input type="checkbox" onchange="_supRdoTarefaUpdate('${t.id}','atrasada',this.checked)"
          style="width:14px;height:14px;accent-color:var(--sc-info)">
        Tarefa com atraso / em risco
      </label>
    </div>`;
  }).join('');
}

// ─── Expor helpers no window (inline handlers do template) ─────────────
function _exposeHandlers() {
  window.selecionarClima = selecionarClima;
  window._pcRdoAddFuncao = _pcRdoAddFuncao;
  window._pcRdoUpdateFuncao = _pcRdoUpdateFuncao;
  window._pcRdoRemoveFuncao = _pcRdoRemoveFuncao;
  window._pcRdoSetDDS = _pcRdoSetDDS;
  window._pcRdoToggleEPI = _pcRdoToggleEPI;
  window._pcRdoAddParalisacao = _pcRdoAddParalisacao;
  window._pcRdoUpdateParalisacao = _pcRdoUpdateParalisacao;
  window._pcRdoRemoveParalisacao = _pcRdoRemoveParalisacao;
  window._supRdoTarefaUpdate = _supRdoTarefaUpdate;
}

// ─── salvarRDO ────────────────────────────────────────────────────────────
async function salvarRDO(obraId) {
  const atividades = document.getElementById('m-atividades')?.value?.trim();
  const data = document.getElementById('m-data')?.value;
  if (!atividades) { showToast('Atividades realizadas é obrigatório.', 'error'); return false; }

  const descricao = `[RDO] ${atividades}`;
  const efetivoFuncaoLimpo = (_pcRdoV4.efetivoPorFuncao || []).filter((f) => (f.funcao || '').trim() && (parseInt(f.qtd) || 0) > 0);
  const paralisacoesLimpas = (_pcRdoV4.paralisacoes || []).filter((p) => (p.motivo || '').trim() || p.inicio || p.fim);
  const somaEfetivoFuncao = efetivoFuncaoLimpo.reduce((s, f) => s + (parseInt(f.qtd) || 0), 0);
  const efetivoTotalFinal = parseInt(document.getElementById('m-efetivo')?.value || 0) || somaEfetivoFuncao || 0;

  const { data: reg, error } = await sb.from('registros_obra').insert({
    obra_id: obraId, descricao, data_registro: data, usuario_id: tenant.user?.id,
    clima: rdoClima || null,
    fornecimento_agua: document.getElementById('m-agua')?.value || 'normal',
    fornecimento_energia: document.getElementById('m-energia')?.value || 'normal',
    efetivo_total: efetivoTotalFinal,
    efetivo_por_funcao: efetivoFuncaoLimpo.length ? efetivoFuncaoLimpo : null,
    equipamentos: document.getElementById('m-equip')?.value || null,
    atividades_realizadas: atividades,
    ocorrencias: document.getElementById('m-ocor')?.value || null,
    observacoes: document.getElementById('m-obs')?.value || null,
    tarefas_acompanhadas: Object.keys(_supRdoTarefasData).length ? _supRdoTarefasData : null,
    dds_realizado: _pcRdoV4.ddsRealizado,
    epis_em_uso: (_pcRdoV4.episEmUso || []).length ? _pcRdoV4.episEmUso : null,
    ocorrencias_seguranca: document.getElementById('m-ocorr-seg')?.value || null,
    paralisacoes: paralisacoesLimpas.length ? paralisacoesLimpas : null,
    materiais_recebidos: document.getElementById('m-mat-receb')?.value || null,
    materiais_aplicados: document.getElementById('m-mat-aplic')?.value || null,
    empresa_id: tenant.empresaId,
  }).select().single();

  if (error) { showToast(error.message, 'error'); return false; }

  // Upload fotos
  const files = [...(document.getElementById('m-fotos')?.files || [])];
  for (let file of files) {
    file = await comprimirImagem(file);
    const path = `rdo/${obraId}/${reg.id}/${Date.now()}_${file.name.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-zA-Z0-9._-]/g,'_')}`;
    const { error: upErr } = await sb.storage.from('obras-files').upload(path, file);
    if (!upErr) {
      const { data: { publicUrl } } = sb.storage.from('obras-files').getPublicUrl(path);
      await sb.from('fotos_rdo').insert({ registro_id: reg.id, obra_id: obraId, url: publicUrl, nome_arquivo: file.name });
    }
  }

  showToast('RDO salvo com sucesso!', 'success');
  _onSavedCb?.();
  return true;
}

// ─── Abrir modal ──────────────────────────────────────────────────────────
export function openModalNovoRDO(obraId, onSaved) {
  _onSavedCb = onSaved || null;
  _exposeHandlers();

  const body = `
    <div class="rdo-section">
      <div class="rdo-section-title">Data e Identificação</div>
      <div class="grid-2">
        <div class="form-group"><label>Data *</label><input type="date" id="m-data" value="${new Date().toISOString().slice(0, 10)}"></div>
        <div class="form-group"><label>Efetivo (nº de trabalhadores)</label><input type="number" id="m-efetivo" placeholder="0" min="0"></div>
      </div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Condições Climáticas</div>
      <div class="clima-opts">
        <div class="clima-opt" onclick="selecionarClima('ensolarado',this)">Ensolarado</div>
        <div class="clima-opt" onclick="selecionarClima('nublado',this)">Nublado</div>
        <div class="clima-opt" onclick="selecionarClima('chuvoso',this)">Chuvoso</div>
        <div class="clima-opt" onclick="selecionarClima('tempestade',this)">Tempestade</div>
        <div class="clima-opt" onclick="selecionarClima('parcialmente_nublado',this)">Parcialmente nublado</div>
      </div>
      <div class="grid-2" style="margin-top:10px">
        <div class="form-group"><label>Fornecimento de Água</label><select id="m-agua"><option value="normal">Normal</option><option value="interrompido">Interrompido</option><option value="parcial">Parcial</option></select></div>
        <div class="form-group"><label>Fornecimento de Energia</label><select id="m-energia"><option value="normal">Normal</option><option value="interrompido">Interrompido</option><option value="parcial">Parcial</option></select></div>
      </div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Atividades Realizadas *</div>
      <textarea id="m-atividades" rows="3" placeholder="Descreva as atividades executadas hoje..."></textarea>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Equipamentos Utilizados</div>
      <textarea id="m-equip" rows="2" placeholder="Ex: Betoneira, Escavadeira, Andaimes..."></textarea>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Ocorrências / Problemas</div>
      <textarea id="m-ocor" rows="2" placeholder="Acidentes, paralisações, imprevistos..."></textarea>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Observações Gerais</div>
      <textarea id="m-obs" rows="2" placeholder="Observações adicionais..."></textarea>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Efetivo por Função</div>
      <div id="pc-rdo-efetivo-list"></div>
      <div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">
        <button type="button" onclick="_pcRdoAddFuncao()"
          style="padding:8px 14px;border-radius:8px;border:0.5px solid var(--border);background:transparent;color:var(--text);font-size:12px;font-weight:600;cursor:pointer">
          + Adicionar função
        </button>
        <span id="pc-rdo-efetivo-soma" style="font-size:11px;color:var(--text3)">sem totais por função</span>
      </div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Conformidade NR-18 / Segurança</div>
      <div style="margin-bottom:10px">
        <label style="font-size:11px;color:var(--text3);display:block;margin-bottom:6px">DDS — Diálogo Diário de Segurança</label>
        <div style="display:flex;gap:6px">
          <button type="button" data-pc-dds="true" onclick="_pcRdoSetDDS(true)"
            style="flex:1;padding:9px 12px;border-radius:8px;font-size:13px;cursor:pointer;border:1px solid var(--border);background:transparent;color:var(--text)">✓ Realizado</button>
          <button type="button" data-pc-dds="false" onclick="_pcRdoSetDDS(false)"
            style="flex:1;padding:9px 12px;border-radius:8px;font-size:13px;cursor:pointer;border:1px solid var(--border);background:transparent;color:var(--text)">✗ Não realizado</button>
        </div>
      </div>
      <div style="margin-bottom:10px">
        <label style="font-size:11px;color:var(--text3);display:block;margin-bottom:6px">EPIs em uso (clique para marcar)</label>
        <div style="display:flex;gap:6px;flex-wrap:wrap" id="pc-rdo-epis">
          ${_pcEPI_OPTIONS.map((e) => `
            <button type="button" data-pc-epi="${e.v}" onclick="_pcRdoToggleEPI('${e.v}',this)"
              style="padding:7px 14px;border-radius:18px;font-size:12px;cursor:pointer;border:1px solid var(--border);background:transparent;color:var(--text)">${e.l}</button>`).join('')}
        </div>
      </div>
      <div class="form-group">
        <label>Ocorrências de Segurança (acidentes, quase-acidentes, fiscalização)</label>
        <textarea id="m-ocorr-seg" rows="2" placeholder="Descreva ocorrências relacionadas à NR-18 / segurança..."></textarea>
      </div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Paralisações</div>
      <div id="pc-rdo-paralisacao-list"></div>
      <button type="button" onclick="_pcRdoAddParalisacao()"
        style="padding:8px 14px;border-radius:8px;border:0.5px solid var(--border);background:transparent;color:var(--text);font-size:12px;font-weight:600;cursor:pointer">
        + Registrar paralisação
      </button>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Materiais</div>
      <div class="grid-2">
        <div class="form-group">
          <label>Recebidos</label>
          <textarea id="m-mat-receb" rows="2" placeholder="Ex: 20 sacos cimento, 5m³ areia..."></textarea>
        </div>
        <div class="form-group">
          <label>Aplicados</label>
          <textarea id="m-mat-aplic" rows="2" placeholder="Ex: 15 sacos cimento concretagem pilar P1..."></textarea>
        </div>
      </div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Fotos da Obra</div>
      <div class="form-group"><label>Selecione as fotos (múltiplos arquivos)</label><input type="file" id="m-fotos" accept="image/*" multiple></div>
      <div id="fotos-preview" class="rdo-fotos-grid"></div>
    </div>
    <div class="rdo-section">
      <div class="rdo-section-title">Tarefas Acompanhadas no Dia</div>
      <div id="srdo-tarefas-lista" style="color:var(--text3);font-size:13px">Carregando tarefas...</div>
    </div>`;

  openModal({
    title: 'RDO — Relatório Diário de Obra',
    codigo: 'OBR-RDO', sub: 'Registro',
    size: 'large',
    bodyHTML: body,
    buttons: [
      { label: 'Cancelar', action: 'cancel' },
      { label: 'Salvar RDO', kind: 'primary', action: () => salvarRDO(obraId) },
    ],
  });

  // init (equivalente ao setTimeout 100 do monolito; DOM já existe após openModal)
  rdoClima = '';
  _pcRdoInit();
  _supRdoTarefasCache = [];
  _supRdoTarefasData = {};
  _pcRdoRenderEfetivo();
  _pcRdoRenderParalisacoes();
  document.getElementById('m-efetivo')?.addEventListener('input', function () { this.dataset.touched = '1'; });
  _supRdoCarregarTarefas(obraId);
  document.getElementById('m-fotos')?.addEventListener('change', function () {
    const prev = document.getElementById('fotos-preview');
    prev.innerHTML = '';
    [...this.files].forEach((file) => {
      const img = document.createElement('img');
      img.className = 'rdo-foto'; img.src = URL.createObjectURL(file);
      prev.appendChild(img);
    });
  });
}
